var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9C4.225 9 3.98958 8.90208 3.79375 8.70625C3.59792 8.51042 3.5 8.275 3.5 8V2C3.5 1.725 3.59792 1.48958 3.79375 1.29375C3.98958 1.09792 4.225 1 4.5 1H9C9.275 1 9.51042 1.09792 9.70625 1.29375C9.90208 1.48958 10 1.725 10 2V8C10 8.275 9.90208 8.51042 9.70625 8.70625C9.51042 8.90208 9.275 9 9 9H4.5ZM4.5 8H9V2H4.5V8ZM2.5 11C2.225 11 1.98958 10.9021 1.79375 10.7063C1.59792 10.5104 1.5 10.275 1.5 10V3H2.5V10H8V11H2.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCopy);
export default __webpack_public_path__ + "static/media/content_copy.ae5ef0d269a1ba0fb13bf243cd5b4ccb.svg";
export { ForwardRef as ReactComponent };